// frontend/src/components/BreadcrumbComponent.js
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Breadcrumbs, Typography, Link, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { alpha, useTheme } from '@mui/material/styles';

const BREADCRUMB_LABELS = {
    'batch-print': 'Batch Print',
    'print-batch-audit': 'Batch Print Audit',
    'print-workflow-settings': 'Print Workflow Settings',
};

const formatBreadcrumb = (value) => (
    BREADCRUMB_LABELS[value] || value.charAt(0).toUpperCase() + value.slice(1)
);

const BreadcrumbComponent = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: theme.palette.text.secondary,
                    '& .MuiBreadcrumbs-separator': {
                        color: alpha(theme.palette.text.primary, 0.28),
                        mx: 0.5,
                    },
                }}
            >
                <Link
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '0.82rem',
                        fontWeight: 500,
                    }}
                    underline="hover"
                    color="inherit"
                    component={RouterLink}
                    to="/dashboard"
                >
                    Home
                </Link>
                {pathnames.map((value, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;

                    return isLast ? (
                        <Typography
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '0.82rem',
                                fontWeight: 700,
                            }}
                            color="text.primary"
                            key={value}
                        >
                            {formatBreadcrumb(value)}
                        </Typography>
                    ) : (
                        <Link
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '0.82rem',
                                fontWeight: 500,
                            }}
                            underline="hover"
                            color="inherit"
                            component={RouterLink}
                            to={routeTo}
                            key={value}
                        >
                            {formatBreadcrumb(value)}
                        </Link>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
};

export default BreadcrumbComponent;

